import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'safeHtml',
	standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(value: string | null | undefined): SafeHtml {
		if (!value) return this.sanitizer.bypassSecurityTrustHtml('');

		// Corregir problemas comunes en el HTML almacenado:
		// - Eliminar entidades escapadas con barra invertida como \&quot;
		// - Eliminar comillas escapadas como \"
		let cleaned = value.replace(/\\&quot;/g, '&quot;').replace(/\\\"/g, '"');

		// Analizar como HTML y normalizar atributos de los enlaces (src -> href, quitar comillas alrededor)
		try {
			const parser = new DOMParser();
			const doc = parser.parseFromString(cleaned, 'text/html');
			const anchors = doc.querySelectorAll('a');
			anchors.forEach((a) => {
				// Mover de `src` a `href`
				if (a.hasAttribute('src')) {
					const src = a.getAttribute('src') || '';
					a.setAttribute('href', src);
					a.removeAttribute('src');
				}

				// Limpiar valores de atributos que pueden tener comillas o barras invertidas adicionales
				['href', 'target'].forEach((attr) => {
					const val = a.getAttribute(attr);
					if (!val) return;
					let v = val.trim();
					// Eliminar comillas simples/dobles alrededor
					if ((v.startsWith('"') && v.endsWith('"')) || (v.startsWith("'") && v.endsWith("'"))) {
						v = v.slice(1, -1);
					}
					// Eliminar barras invertidas sobrantes
					v = v.replace(/\\+/g, '');
					a.setAttribute(attr, v);
				});
			});

			cleaned = doc.body.innerHTML;
		} catch (e) {
			// Si el análisis falla, usar la cadena limpiada
		}

		return this.sanitizer.bypassSecurityTrustHtml(cleaned || '');
	}
}
